import { useCallback, useEffect, useState } from 'react';
import { IAsyncType, useFlag } from '.';
import {
  ItemDeliveryBatchResponse,
  amsV3Service
} from '../../services';
import { promiseAllInBatches } from '../utils';

export interface IItemsLastItemBatch<T> extends IAsyncType<T> {
  itemsLastItemBatch: T;
}

const useItemsLastItemBatch = (
  ids: number[] | null,
): IItemsLastItemBatch<Map<string, ItemDeliveryBatchResponse | null>> => {
  const [data, setData] = useState<Map<string, ItemDeliveryBatchResponse | null>>(new Map());
  const [loading, setLoading] = useFlag(true);
  const [parameters, setParameters] = useState<any[] | null>(ids);

  const fetchData = useCallback(async () => {
    setLoading(true);
    if (!parameters || parameters.length === 0) {
      setLoading(false);
      return;
    }
    const results = await promiseAllInBatches(amsV3Service.getItemLastItemBatch, parameters, 5);
    if (results) {
      setData(results);
    }
    setLoading(false);
  }, [parameters, setLoading]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    itemsLastItemBatch: data,
    loading,
    setLoading,
    parameters,
    setParameters
  };
};

export default useItemsLastItemBatch;
